export default "/images/d7ad7f1b75dcb74f9f02e63129e343c6.avif";